import { useEffect, useState } from "react";
import { Container, Text, Title, Paper, Loader, Button } from "@mantine/core";
import { useStore } from "../store";
import { getMyProfile } from "../api";

function PaymentSuccess() {
  const setProfile = useStore((state) => state.setProfile);
  const [isLoading, setIsLoading] = useState(true);

  function sleeper(ms) {
    return function (x) {
      return new Promise((resolve) => setTimeout(() => resolve(x), ms));
    };
  }

  useEffect(() => {
    // Wait 2s for the webhooks to update the profile, then fetch
    sleeper(2000)().then(() => {
      getMyProfile().then((data) => {
        setProfile(data);
        setIsLoading(false);
      });
    });
  }, [setProfile]);

  return (
    <Container size="sm" ta="center">
      <Paper mt="xl" p="lg" withBorder>
        <Title mb="md" order={2}>
          Payment Successful
        </Title>

        {isLoading ? (
          <>
            <Loader />
            <Text>Thanks! Your payment is on the way.</Text>
          </>
        ) : (
          <div>
            <Text>Your profile should reflect the changes now.</Text>
            <Button component="a" href="/gallery" mt="lg">
              Proceed
            </Button>
          </div>
        )}
      </Paper>
    </Container>
  );
}

export default PaymentSuccess;
